import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-company-news',
  templateUrl: './company-news.component.html',
  styleUrls: ['./company-news.component.scss'],
})
export class CompanyNewsComponent implements OnInit {
  @Output() itemAddedToCart: EventEmitter<any> = new EventEmitter();

  @Input() cin: any;
  @Input() all_data: any;
  @ViewChild('funding') funding: ElementRef<HTMLElement>;
  @ViewChild('general') general: ElementRef<HTMLElement>;
  @ViewChild('financial') financial: ElementRef<HTMLElement>;

  hideFunding= false;
  hideFinancial = false;
  hideGeneral = false;

  fragment: string;

  constructor(private route: ActivatedRoute) {}
  ngOnInit(): void {
    this.route.fragment.subscribe((fragment) => {
      this.fragment = fragment;
    });
  }

  ngAfterViewChecked(): void {
    try {
      if (this.fragment) {
        document.getElementById(this.fragment).scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest',
        });
      }
    } catch (e) {}
  }
}
